export default __webpack_public_path__ + "static/media/bhurva.30fa0fb9.svg";